<template>
    <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" :lock-scroll="true" width="818px"
        :before-close="handleClose">
        <el-form :rules="rules" ref="formRules" :model="form">
            <el-row class="reject-c">
                <el-form-item prop="activityId" label="商品范围：">
                    <el-radio-group v-model="form.goodsRange">
                        <el-radio :label="0">基准库商品</el-radio>
                        <el-radio :label="1">指定店铺全部商品</el-radio>
                        <el-radio :label="2">店铺指定商品</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div class="select-shop" v-show="form.goodsRange == 0">
                    <span>已选{{ goodsBaseQuantity }}</span> <el-button type="primary" size="small"
                        @click="chooseGoodsBase">选择商品</el-button>
                </div>
                <div class="select-shop" v-show="form.goodsRange == 1">
                    <el-select v-model="shopIdArr" multiple filterable remote reserve-keyword placeholder="请输入关键词搜索店铺"
                        size="small" :remote-method="remoteMethod" :loading="loading" style="width: 350px;">
                        <el-option v-for="item in options" :key="item.id" :label="item.shopName" :value="item.id">
                            <span style="float: left">{{ item.shopName }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px;padding-left: 20px;">
                                <span v-if="item.companyName"> {{ item.companyName }}/</span> <span
                                    v-if="item.concatName">{{ item.concatName }}/</span> <span v-if="item.concatPhone">{{
                                        item.concatPhone }}/</span> 在售商品数:{{ item.onSaleCount }}</span>
                        </el-option>
                    </el-select>
                </div>
                <div class="select-shop" v-show="form.goodsRange == 2">
                    <el-select v-model="shopIdArr" multiple filterable remote reserve-keyword placeholder="请输入关键词搜索店铺"
                        style="width: 350px; margin-right: 10px;" size="small" :remote-method="remoteMethod"
                        :loading="loading">
                        <el-option v-for="item in options" :key="item.id" :label="item.shopName" :value="item.id">
                            <span style="float: left">{{ item.shopName }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px;padding-left: 20px;">
                                <span v-if="item.companyName"> {{ item.companyName }}/</span> <span
                                    v-if="item.concatName">{{ item.concatName }}/</span> <span v-if="item.concatPhone">{{
                                        item.concatPhone }}/</span> 在售商品数:{{ item.onSaleCount }}</span>
                        </el-option>
                    </el-select>
                    <span style="padding-right:5px ;">已选{{ goodsShopQuantity }}</span>
                    <el-button type="primary" size="small" :disabled="!shopIdArr.length"
                        @click="chooseGoods">选择商品</el-button>

                </div>
            </el-row>
            <el-form-item label="参与要求：">
                <div>
                    <el-form-item prop="skuInventoryMin" style="display: inline-block;">
                        <span>SKU活动库存下限
                            <el-input v-model="form.skuInventoryMin" placeholder="请输入" clearable size="small"
                            maxlength="6" v-positive-integer
                                style="width: 100px; margin:0 5px" />
                        </span>
                    </el-form-item>
                    <el-form-item prop="skuPriceMax" style="display: inline-block;">
                        <span>SKU活动价格上限 <el-input v-model="form.skuPriceMax" placeholder="请输入" clearable size="small"
                            v-positive-six-limit
                                style="width: 100px; margin:0 5px" />
                        </span>
                    </el-form-item>
                </div>
            </el-form-item>
            <div class="btnBox">
                <el-button size="small" @click="handleClose">返回</el-button>
                <el-button type="primary" size="small" @click="submit">确认</el-button>
            </div>
        </el-form>
        <!-- 店铺指定商品 -->
        <goodsDialog v-if="visible" ref="goodsDialog" @didSelectItem="didSelectItem" />

        <!-- 基准库商品 -->
        <goodsDialog v-if="visible" ref="goodsBaseDialog" dialogType="goodsBaseTag"
            @didSelectItem="didSelectGoodsBaseList" />
    </el-dialog>
</template>
      
<script>
import wangEnduit from "@/components/wangEnduit";
import goodsDialog from './goodsDialog';
import { queryShopListByKeyword, activityRulesAdd } from "@/api/platActivityManage";
import { moneyFix, checkNumber } from '@/utils/validate'
export default {
    components: {
        wangEnduit,
        goodsDialog
    },
    props: {
        goodsFrom: {
            type: [Number, String],
            default: 0
        }
    },
    data() {
        return {
            form: this.initForm(),
            rules: {
                skuPriceMax: [{ required: true, validator: moneyFix, trigger: 'blur' }],
                skuInventoryMin: [{ required: true, validator: checkNumber, trigger: 'blur' }]
            },
            title: '',
            visible: false,
            loading: false,
            submitLoading: false,
            options: [],
            shopIdArr: [], // 店铺IDs
            pageType: ''
        }
    },

    created() {

    },
    mounted() {
    },
    computed: {
        goodsBaseQuantity() {
            // 基准库商品数量
            return this.form.goodsBaseList.length
        },
        goodsShopQuantity() {
            // 店铺指定商品数量
            return this.form.goodsSkuBaseList.length
        }
    },
    watch: {},
    methods: {
        initForm() {
            return {
                activityId: '', // 活动id
                goodsRange: 0, // 0基准库商品 1指定店铺全部商品 2店铺指定
                skuInventoryMin: '', // SKU活动库存下限
                skuPriceMax: '', // SKU活动价格上限
                goodsBaseList: [],  // 基准库商品信息
                shopList: [], // 商户信息
                goodsSkuBaseList: [], // 商品sku信息
            }
        },
        // 初始创建清空数据
        initCreate() {
            this.shopIdArr = [];
            this.options = [];
            this.form = this.initForm()
        },
        async submit() {
            if (this.form.goodsRange == 1 || this.form.goodsRange == 2) {
                if (!this.shopIdArr.length) {
                    this.$message.warning('请选择店铺')
                    return
                }
            }
            if (this.form.goodsRange == 2 && !this.form.goodsSkuBaseList.length) {
                this.$message.warning('请选择商品')
                return
            }
            if (this.form.goodsRange == 0 && !this.form.goodsBaseList.length) {
                this.$message.warning('请选择商品')
                return
            }
            if (!this.form.skuInventoryMin) {
                this.$message.warning('请输入SKU活动库存下限')
                return
            }
            if (!this.form.skuPriceMax) {
                this.$message.warning('请输入SKU活动价格上限')
                return
            }

            await this.$refs['formRules'].validate();
            const { goodsSkuBaseList = [], goodsBaseList = [], shopList, ...form } = this.form;
            let params = {
                ...form,
                activityId: this.$route.query.id,
                goodsFrom: this.goodsFrom, // 商品来源：0平台添加 1 商户添加
            };
            switch (form.goodsRange) {
                case 0:
                    params.goodsBaseList = goodsBaseList
                    break;
                case 1:
                    params.shopList = this.options.filter(item => this.shopIdArr.some(id => id === item.id));
                    break;
                case 2:
                    params.goodsSkuBaseList = goodsSkuBaseList
                    break;
            }
            this.submitLoading = true;
            activityRulesAdd(params).then((res) => {
                if (res) {
                    this.$message.success('操作成功')
                    this.handleClose()
                    this.$emit('refresh')
                }
            }).catch((err) => { }).finally(() => {
                this.submitLoading = false;
            })
        },

        // 选择基础库商品
        chooseGoodsBase() {
            this.$refs.goodsBaseDialog.init({ pageType: this.pageType })
        },
        chooseGoods() {
            this.$refs.goodsDialog.init({ shopIds: this.shopIdArr, pageType: this.pageType });
        },
        // 选择基准库商品
        didSelectGoodsBaseList(arr) {
            this.form.goodsBaseList = arr;
        },
        // 选择店铺商品 商品sku信息
        didSelectItem(arr) {
            this.form.goodsSkuBaseList = arr;
        },
        remoteMethod(queryString) {
            let params = {
                activityId: this.$route.query.id
            };
            let restaurants = []
            params.keyword = queryString;
            // 根据店铺名或手机号搜索店铺
            queryShopListByKeyword(params).then((res) => {
                if (res) {
                    restaurants = res;
                    if (queryString !== '') {
                        this.loading = true;
                        setTimeout(() => {
                            this.loading = false;
                            this.options = restaurants.filter(item => {
                                if (!item.shopName) return false;
                                return item.shopName.toLowerCase()
                                    .indexOf(queryString.toLowerCase()) > -1;
                            });
                        }, 200);
                    } else {
                        this.options = [];
                    }
                }
            }).catch((err) => { })
        },
        init(row, type) {
            this.title = '活动规则';
            this.visible = true;
            this.form.activityId = this.$route.query.id || '';
            this.pageType = type;
            this.initCreate();
        },
        handleClose() {
            this.visible = false;
        },
    }
}

</script>
<style lang="scss" scoped>
.wang-enduit {
    max-width: 1200px;
}

.select-shop {
    margin-top: -20px;
    margin-left: 85px;
    margin-bottom: 20px;
}
</style>
    
    